// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1_kx7","footer":"ModalFilter_footer__27bL3"};